import { Component } from 'react';
export const noModal = (nodeType, attributes) => {
    return class NoModal extends Component {
        componentDidMount() {
            const nodeOptions = Object.assign(Object.assign(Object.assign({}, this.props.node), { nodeType, isAction: false, isRemovable: true, isEditable: false, payload: {} }), attributes);
            this.props.replaceNode(nodeOptions);
            this.props.triggerClose();
        }
        render() {
            return null;
        }
    };
};
